import { FC } from 'react';

import TradePriceCache from '../../../../lib/store-util/TradePriceCache';
import { getPriceColorByDirection } from '../../../../lib/util/ChartingHelpers';
import { formatCurrencyBySymbol } from '../../../../lib/util/DataHelpers';
import { INVALID_VALUE } from '../../../../lib/util/types';

import { GapperRow } from '../../HotGappers.types';

import styles from '../../HotGappers.module.scss';

const CHANGE_PERCENT_PRECISION = 2;

type Props = { item: GapperRow };

const PriceAndChange: FC<Props> = (props: Props): JSX.Element => {
  const { item } = props;
  const { lookupSymbol, currencySymbol, isEuropeanSymbol } = item;
  const { currentPrice, changePercent, direction } = TradePriceCache.use(lookupSymbol, 'SymbolTradeInfoCard');

  if (!item) {
    return <>{INVALID_VALUE}</>;
  }
  const color = getPriceColorByDirection(direction);

  return (
    <div className={styles.priceAndChangeContainer}>
      <span className={styles.priceAndChange}>
        {formatCurrencyBySymbol(currentPrice ?? INVALID_VALUE, currencySymbol, { isEuropeanSymbol })}
      </span>
      <p style={{ color }}>
        {direction}
        {changePercent ?? item.changePercent.toFixed(CHANGE_PERCENT_PRECISION)}
      </p>
    </div>
  );
};

export default PriceAndChange;
